import { AdvancedEventEmitter, EventBroker, IEventBroker } from '@zdrbm/zdr-native-tools';

export interface IAbortController {
    abort(): void;

    onAbort: IEventBroker;
    isAborted: boolean;
}

export class PlAbortController extends AdvancedEventEmitter implements IAbortController {
    onAbort: IEventBroker<any>;
    isAborted: boolean;

    constructor() {
        super();
        this.onAbort = new EventBroker(this);
        this.isAborted = false;
    }

    abort(): void {
        this.onAbort.emit(undefined);
        this.isAborted = true;
    }
}
